import classes from "./Header.module.css"
import {Box} from "@mantine/core";
import cx from "clsx";
import commonClasses from "../../../common/common.module.css"
import {DashboardIcons} from "../common/constants";

interface HeaderProps {
    title: string;
    subtitle: string;
}

export const Header = ({title, subtitle}: HeaderProps) => {
    return (
        <Box className={cx(classes.root, commonClasses.mediumLightBlueGradient90, commonClasses.sbRadius)}>
            <Box style={{display:"flex", flexDirection:"row", alignItems:"center"}}>
                <Box className={cx(classes.icons, commonClasses.sbRadius)}>
                    <DashboardIcons.megScanIcon size={"1.5em"}/>
                    <DashboardIcons.activityIcon size={"1.5em"}/>
                    <DashboardIcons.stimulationsIcon size={"1.5em"}/>
                </Box>
                <Box className={cx(classes.title)}>{title}</Box>
            </Box>
            <Box className={cx(classes.subtitle)}>{subtitle}</Box>
        </Box>
    );
};